import React from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"

import "./Auth.scoped.scss"
import { PublicLayout } from "layouts/Public"
import { FormForgotPassword } from "./Partials"
import { publicRoutes } from "router/routes"

export const ForgotPasswordPage = () => {
    const { t } = useTranslation()
    return (
        <PublicLayout className="login-page">
            <div className={"blur"}></div>

            <div className="l-form-width mb-7 mx-auto">
                <h1 className="c-h1 font-semibold text-center mb-5 text-white">
                    {t("forgot_password.title", { ns: "auth" })}
                </h1>
                <NavLink to={publicRoutes.login.path} className="u-block text-xs text-center underline mb-7 text-white">
                    {t("forgot_password.backlink", { ns: "auth" })}
                </NavLink>
            </div>

            <div className="mb-12">
                <div className="l-form-width mx-auto mb-7 text-white">
                    <p className="mb-5">{t("forgot_password.introduction_1", { ns: "auth" })}</p>
                    <p className="mb-5">{t("forgot_password.introduction_2", { ns: "auth" })}</p>
                </div>
                <div className="c-card p-5 lg:px-12 lg:py-7  l-form-width mx-auto">
                    <FormForgotPassword />
                </div>
            </div>
        </PublicLayout>
    )
}

